import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "disabled", "inputProps", "max", "min", "minusButtonProps", "onChange", "plusButtonProps", "step", "theme", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { MinusLinear, PlusLinear } from "../icons";
import noop from "../utils/noop";
import { isNumber } from "../utils/type";
import { Button, roundThemes } from '../Button';
import styles from './NumberField.css';
var cx = classNames.bind(styles);
var BUTTON_PROPS = {
  primary: true,
  radius: 16,
  round: true,
  type: 'button'
};
export var NumberField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      inputProps = _ref.inputProps,
      max = _ref.max,
      min = _ref.min,
      minusButtonProps = _ref.minusButtonProps,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      plusButtonProps = _ref.plusButtonProps,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? roundThemes.b2c : _ref$theme,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getValue = function getValue(val) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var result = Number(val) + action;

    if (isNumber(min) && result <= min) {
      return min;
    }

    if (isNumber(max) && result >= max) {
      return max;
    }

    return result;
  };

  var handleChange = function handleChange(e) {
    return onChange(getValue(+e.currentTarget.value));
  };

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cx('root', classes.root),
    ref: ref
  }), /*#__PURE__*/React.createElement(Button, _extends({
    disabled: isNumber(min) && value <= min || disabled,
    theme: theme,
    onClick: function onClick() {
      return onChange(getValue(value, -step));
    }
  }, _objectSpread(_objectSpread({
    children: /*#__PURE__*/React.createElement(MinusLinear, null)
  }, BUTTON_PROPS), minusButtonProps))), /*#__PURE__*/React.createElement("input", _extends({
    className: cx('input', classes.input),
    type: "number",
    disabled: disabled,
    max: max,
    min: min,
    step: step,
    onChange: handleChange,
    value: getValue(value),
    maxLength: 2
  }, inputProps)), /*#__PURE__*/React.createElement(Button, _extends({
    disabled: isNumber(max) && value >= max || disabled,
    theme: theme,
    onClick: function onClick() {
      return onChange(getValue(value, step));
    }
  }, _objectSpread(_objectSpread({
    children: /*#__PURE__*/React.createElement(PlusLinear, null)
  }, BUTTON_PROPS), plusButtonProps))));
});
NumberField.displayName = 'NumberField';